import { render, staticRenderFns } from "./DynamicTemplateCreate.vue?vue&type=template&id=58c5ffe7"
import script from "./DynamicTemplateCreate.vue?vue&type=script&lang=js"
export * from "./DynamicTemplateCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports